import React, {FC} from 'react';
import useCustomerContext from "../../customers/hooks/useCustomerContext";
import useTranslate from "../../core/languages/hooks/useTranslate";
import City from "../../cities/types/City";
import Event from "../../events/types/Event";
import TitleCardSection from "./TitleCardSection";

interface EventDetailsSectionProps {
  eventInfo: Event | undefined;
  cityInfo: City | undefined;
}

const EventDetailsSection: FC<EventDetailsSectionProps> = ({eventInfo, cityInfo}) => {
  const t = useTranslate();
  const {languageCode} = useCustomerContext();

  return (
    <div className="mb-10">
      <TitleCardSection
          title={t("transferOk.message.eventDetails")}
          subtitle={t("transferOk.message.eventDetailsSubtitle")}
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div
          className="bg-gradient-to-br from-neutral-50 to-neutral-100 dark:from-neutral-800 dark:to-neutral-900 rounded-2xl p-4 border border-neutral-200 dark:border-neutral-700">
          <div className="flex items-center space-x-3">
            <div className="flex-shrink-0">
              <i className="las la-calendar-alt text-green-700 dark:text-green-400 text-2xl"></i>
            </div>
            <div className="flex-1">
              <p className="text-xs font-medium text-neutral-500 dark:text-neutral-400 uppercase tracking-wide">
                {t("transferOk.fields.event")}
              </p>
              <p className="text-sm font-semibold text-neutral-900 dark:text-neutral-100 mt-1">
                {eventInfo?.name}
              </p>
            </div>
          </div>
        </div>

        <div
          className="bg-gradient-to-br from-neutral-50 to-neutral-100 dark:from-neutral-800 dark:to-neutral-900 rounded-2xl p-4 border border-neutral-200 dark:border-neutral-700">
          <div className="flex items-center space-x-3">
            <div className="flex-shrink-0">
              <i className="las la-map-marker-alt text-green-700 dark:text-green-400 text-2xl"></i>
            </div>
            <div className="flex-1">
              <p className="text-xs font-medium text-neutral-500 dark:text-neutral-400 uppercase tracking-wide">
                {t("bookOk.city")}
              </p>
              <p className="text-sm font-semibold text-neutral-900 dark:text-neutral-100 mt-1">
                {cityInfo?.trName[languageCode]}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventDetailsSection;

